/*
 * premierstreets
 * version 4.5
 * http://www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Api } from '../providers/api/api';

@Injectable()
export class CartService extends Api {
	private base: string;

	/* get cart count api*/
	public getCartCount(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + 'customer-cart/customer-cart-list', {
			params: params
		});
	}


	/* get cart count api*/
	public getPaymentSettings(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + 'orders/payment-settings', {
			params: params
		});
	}


	/* get addToCart api*/
	public doAddToCart(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + 'customer-cart/add-cart', params);
	}
	/* get addToCart api*/
	public deleteCart(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + 'customer-cart/delete-cart-item', params);
	}

	/* get cart api*/
	public GetCartList(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + 'customer-cart/customer-cart-list', { params: params });
	}

	public checkStock(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + 'orders/check-stock', params);
	}

	/* getShippingMethods api*/
	public getShippingMethods(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + 'store-shipping-method/list', { params: params });
	}

	public remainderPaid(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + 'orders/remainder-paid', params);
	}

	/* get shpping settings api*/
	public getShippingSettings(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.get(this.base + 'store-shipping-method/shipping-setting', { params: params });
	}


	/* calculateShippingMethod api*/
	public calculateShippingPrice(params: any): Observable<any> {
		this.base = this.getBaseUrl();
		return this.http.post(this.base + 'store-shipping-method/calculate-shipping-price', params);
	}
}
